import React from "react";

/**
 * ActionCardBody - Reusable body component for action cards
 * Used by both ActionCardView and AppliedActionCard
 */
const ActionCardBody = ({ action, colors, isMobile }) => {
  return (
    <div className={`stock-card-spacer action-card-body ${isMobile ? 'action-card-body-mobile' : 'action-card-body-desktop'}`}>
      {/* Description - shown on both mobile and desktop */}
      <div className={`action-card-description ${isMobile ? 'action-card-description-mobile' : 'action-card-description-desktop'}`}>
        {action.description}
      </div>

      {/* Action Card label - hidden on mobile */}
      {!isMobile && (
        <div className="action-card-label">
          Action Card
        </div>
      )}
    </div>
  );
};

export default ActionCardBody;

